import React from "react";

const DAYS = [
  { day: 0, label: "Su" },
  { day: 1, label: "M" },
  { day: 2, label: "T" },
  { day: 3, label: "W" },
  { day: 4, label: "Th" },
  { day: 5, label: "F" },
  { day: 6, label: "S" },
];

function OpenFilter({ openNow, openOn, onOpenNowChange, onOpenOnChange, showOpenNow, showDaysOpen }) {
  function handleDayClick(day) {
    const dayStr = String(day);
    const current = openOn || [];
    const next = current.includes(dayStr)
      ? current.filter((d) => d !== dayStr)
      : [...current, dayStr];
    onOpenOnChange(next);
  }

  return (
    <div className="open-filters">
      {showOpenNow && (
        <div className="open-now">
          <label className="label-no-transform" htmlFor="open_now">Open Now?</label>
          <input
            className="label-balance open-now-chk"
            name="open_now"
            type="checkbox"
            id="open_now"
            checked={!!openNow}
            onChange={(e) => onOpenNowChange(e.target.checked ? "true" : null)}
          />
        </div>
      )}
      {showDaysOpen && (
        <>
          <div className="filter-section-heading">
            <label className="label-no-transform">Days Open</label>
            <label className="small-text">Select all that apply</label>
          </div>
          <div className="open-filters-table pointer" role="group" aria-label="Days Open">
            <div className="days">
              {DAYS.map((d) => {
                const isActive = (openOn || []).includes(String(d.day));
                return (
                  <button
                    key={d.day}
                    className={`open-on${isActive ? " active" : ""}`}
                    data-day={d.day}
                    type="button"
                    onClick={() => handleDayClick(d.day)}
                  >
                    {d.label}
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default OpenFilter;
